import React from 'react'

const MapComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default MapComponent
